export const ACTION_TYPES = {
    FETCH_START: 'FETCH_START',
    FETCH_SUCCESS:'FETCH_SUCCESS',
    FETCH_ERROR: 'FETCH_ERROR',
    PRODUCT_START:'PRODUCT_START',
    PRODUCT_SUCCESS:'PRODUCT_SUCCESS',
    PRODUCT_ERROR:'PRODUCT_ERROR'
}

export const Products = {
    loading:false,
    data:null,
    error:null
}

export const Product = {
    loading:false,
    item:null,
    error:null
}

export const ProductReducer = (state, action) => {
    switch (action.type) {
        case ACTION_TYPES.FETCH_START:
            return {
                ...state,
                loading:true
            }
        case ACTION_TYPES.FETCH_SUCCESS:
            console.log(action.payload)
            return {
                ...state,
                loading:false,
                data:action.payload
            }
        case ACTION_TYPES.FETCH_ERROR:
            return {
                ...state,
                loading:false,
                error:action.payload
            }
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
}

export const SingleProduct = (state, action) => {
    switch (action.type){
        case  ACTION_TYPES.PRODUCT_START:
            return {
                ...state,
                loading:true
            }
        case ACTION_TYPES.PRODUCT_SUCCESS:
            return {
                ...state,
                loading:false,
                item:action.payload
            }
        case ACTION_TYPES.PRODUCT_ERROR:
            return {
                ...state,
                loading:false,
                error:action.payload
            }
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
}